import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { makeStyles, Box, Theme, Typography } from '@material-ui/core';
import { colors } from '@lifesize/ux-assets';
import { ReactComponent as WarningIcon } from '@lifesize/ux-assets/vectors/svgIcons/warning.svg';
import { highQualityHardwareConcurrencyLimit } from 'constants/Application';

const VbbDisclaimer = () => {
  const classes = useStyles({});
  const showDisclaimer = navigator?.hardwareConcurrency <= highQualityHardwareConcurrencyLimit;
  return (
    <Box>
      {showDisclaimer && (
        <Box className={classes.disclaimerContainer}>
          <Box className={classes.warningSidebar} />
          <Box>
            <Typography variant={'h6'} className={classes.disclaimerTitle}>
              <WarningIcon />
              <FormattedMessage id="components.vbb.disclaimer.warning.title" defaultMessage="Feature Warning" />
            </Typography>
            <Typography className={classes.disclaimerText}>
              <FormattedMessage
                id="components.vbb.disclaimer.warning"
                defaultMessage="Your device doesn’t meet our recommended system requirements for this feature. Using it may result in some issues with your call."
              />
            </Typography>
          </Box>
        </Box>
      )}
    </Box>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  disclaimerContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: theme.spacing(2)
  },
  warningSidebar: {
    border: '3px solid',
    borderColor: colors.warningOrange,
    borderRadius: 3,
    marginRight: theme.spacing(1.5)
  },
  disclaimerTitle: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 12,
    fontWeight: theme.typography.fontWeightMedium,
    marginBottom: theme.spacing(1),
    '& svg': {
      color: colors.warningOrange,
      height: 22,
      marginRight: theme.spacing(1),
      width: 'auto'
    }
  },
  disclaimerText: {
    fontSize: 10
  },
  autoSave: {
    fontSize: 12
  }
}));

export default injectIntl(VbbDisclaimer);
